module.exports = __webpack_public_path__ + "img/trophy.638faf6c.svg";